import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref} from 'vue';
import DomHelper from "~/ts/library/DomHelper";
import {DraggableResizablePointerEventInterface} from "~/cabinet/vue/interface/draggableResizable/DragAndDrop";
import {isTouchScreen} from "~/cabinet/vue/interface/draggableResizable/isTouchScreen";


const __default__ = {
    name: "PointerEventContainer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tagName: { default: "div" }
  },
  emits: ["drag-start", "drag", "drag-stop", "click", "touchmove", "touchstart", "touchend"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let dragActive = ref(false);
let wasDrag = ref(false);

const hasPointerEventSupport = 'PointerEvent' in window && !isTouchScreen.value;

function onDragStart(e: PointerEvent | TouchEvent, isPointer?: boolean, isTouch?: boolean) {
    let pointerEvent: PointerEvent = isTouch ? null : e as any;
    let touchEvent: TouchEvent = isTouch ? e as any : null;
    if (touchEvent) {
        emits("touchstart", touchEvent);
        if (touchEvent.touches.length > 1) {
            return;
        }
    }
    //Отключили срабатывание на select из-за хуйни в сафари - там не срабатывает onmouseup на select
    if ((!isPointer && hasPointerEventSupport) || (!isTouch && isTouchScreen.value) || (pointerEvent && pointerEvent.button != 0) || (e.target as HTMLElement).tagName == "SELECT") {
        return;
    }

    wasDrag.value = false;

    var el = e.target as HTMLElement;
    if (pointerEvent) {
        DomHelper.setPointerCapture(el as HTMLElement, pointerEvent.pointerId);
    }
    dragActive.value = true;

    emits("drag-start", pointerEvent ? pointerEvent : touchEvent.touches[0]);
    e.stopPropagation();
}

function onDragStop(e: PointerEvent | TouchEvent, isPointer?: boolean, isTouch?: boolean) {
    let pointerEvent: PointerEvent = isTouch ? null : e as any;
    let touchEvent: TouchEvent = isTouch ? e as any : null;
    if (touchEvent) {
        emits("touchend", touchEvent);
        if (touchEvent.touches.length > 1) {
            return;
        }
    }
    if ((!isPointer && hasPointerEventSupport) || (!isTouch && isTouchScreen.value)) {
        return;
    }
    if (dragActive.value) {
        dragActive.value = false;
        if (!wasDrag.value) {
            if (!pointerEvent || pointerEvent.button == 0) {
                emits("click", pointerEvent ? pointerEvent : touchEvent.touches[0]);
            }
        }
        if (pointerEvent) {
            DomHelper.releasePointerCapturer(e.target as HTMLElement, pointerEvent.pointerId);
        }
        emits("drag-stop", pointerEvent ? pointerEvent : touchEvent.touches[0]);
        e.stopPropagation();
    }
}

function onDrag(e: PointerEvent | TouchEvent, isPointer?: boolean, isTouch?: boolean) {
    let pointerEvent: PointerEvent = isTouch ? null : e as any;
    let touchEvent: TouchEvent = isTouch ? e as any : null;
    if (touchEvent) {
        emits("touchmove", touchEvent);
        if (touchEvent.touches.length > 1) {
            return;
        }
    }
    if ((!isPointer && hasPointerEventSupport) || (!isTouch && isTouchScreen.value)) {
        return;
    }
    if (dragActive.value) {
        wasDrag.value = true;
        emits("drag", pointerEvent ? pointerEvent : touchEvent.touches[0]);
        e.stopPropagation();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tagName), {
    onMousedown: onDragStart,
    onMousemove: onDrag,
    onMouseup: onDragStop,
    onPointerdown: _cache[0] || (_cache[0] = ($event: any) => (onDragStart($event, true))),
    onPointermove: _cache[1] || (_cache[1] = ($event: any) => (onDrag($event, true))),
    onPointerup: _cache[2] || (_cache[2] = ($event: any) => (onDragStop($event, true))),
    onTouchstartPassive: _cache[3] || (_cache[3] = ($event: any) => (onDragStart($event, false, true))),
    onTouchendPassive: _cache[4] || (_cache[4] = ($event: any) => (onDragStop($event, false, true))),
    onTouchmovePassive: _cache[5] || (_cache[5] = ($event: any) => (onDrag($event, false, true)))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 32))
}
}

})